module.exports = __webpack_public_path__ + "img/BankID_logo_neg.96079413.png";